
! function(t) {
    var e = function(e, i) {
        return this.$element = t(e), this.$element.is("input") ? (this.options = t.extend({}, t.fn.combodate.defaults, i, this.$element.data()), void this.init()) : void t.error("Combodate should be applied to INPUT element")
    };
    e.prototype = {
        constructor: e,
        init: function() {
            this.map = {
                day: ["D", "date"],
                month: ["M", "month"],
                year: ["Y", "year"],
                hour: ["[Hh]", "hours"],
                minute: ["m", "minutes"],
                second: ["s", "seconds"],
                ampm: ["[Aa]", ""]
            }, this.$widget = t('<span class="combodate"></span>').html(this.getTemplate()), this.initCombos(), this.$widget.on("change", "select", t.proxy(function(e) {
                this.$element.val(this.getValue()).change(), this.options.smartDays && (t(e.target).is(".month") || t(e.target).is(".year")) && (this.fillCombo("day"), this.$element.parent().find(".formselect.day").selectpicker("refresh"))
            }, this)), this.$widget.find("select").css("width", "auto"), this.$element.hide().after(this.$widget), this.setValue(this.$element.val() || this.options.value)
        },
        getTemplate: function() {
            var e = this.options.template,
                i = this.options.customClass;
            
            var inputDisabled = this.$element.prop('disabled');
            var inputId = this.$element.prop('id');
            
            return t.each(this.map, function(t, i) {
                i = i[0];
                var o = new RegExp(i + "+"),
                    s = i.length > 1 ? i.substring(1, 2) : i;
                e = e.replace(o, "{" + s + "}")
            }), e = e.replace(/ /g, ""), t.each(this.map, function(t, o) {
                o = o[0];
                var s = o.length > 1 ? o.substring(1, 2) : o;
                e = e.replace("{" + s + "}", '<select data-v-id="' + inputId + '" data-width="32%" '+ (inputDisabled ? ' disabled="disabled"' : '')+' data-style="btn-lg btn-outline-secondary " class="' + t + " " + i + '"></select>')
            }), e
        },
        initCombos: function() {
            for (var t in this.map) {
                var e = this.$widget.find("." + t);
                this["$" + t] = e.length ? e : null, this.fillCombo(t)
            }
        },
        fillCombo: function(t) {
            var e = this["$" + t];
            if (e) {
                var i = "fill" + t.charAt(0).toUpperCase() + t.slice(1),
                    o = this[i](),
                    s = e.val();
                e.empty();
                for (var n = 0; n < o.length; n++) e.append('<option value="' + o[n][0] + '">' + o[n][1] + "</option>");
                e.val(s)
            }
        },
        fillCommon: function(t) {
            var e, i = [];
            var o;
            if ("name" === this.options.firstItem) {
                if (moment.localeData()._abbr == "ar") {
                    e = moment.relativeTime || moment.localeData().__relativeTime;
                    o = "string" == typeof e[t] && e[t];
                    i.push(["", o]);
                } else {
                    e = moment.relativeTime || moment.localeData()._relativeTime;
                    o = "function" == typeof e[t] ? e[t](1, !0, t, !1) : e[t];
                    o = o.split(" ").reverse()[0], i.push(["", o])
                }
            } else "empty" === this.options.firstItem && i.push(["", ""]);
            return i
        },
        fillDay: function() {
            var t, e, i = this.fillCommon("d"),
                o = -1 !== this.options.template.indexOf("DD"),
                s = 31;
            if (this.options.smartDays && this.$month && this.$year) {
                var n = parseInt(this.$month.val(), 10),
                    a = parseInt(this.$year.val(), 10);
                isNaN(n) || isNaN(a) || (s = moment([a, n]).daysInMonth())
            }
            for (e = 1; s >= e; e++) t = o ? this.leadZero(e) : e, i.push([e, t]);
            return i
        },
        fillMonth: function() {
            var t, e, i = this.fillCommon("M"),
                o = -1 !== this.options.template.indexOf("MMMM"),
                s = -1 !== this.options.template.indexOf("MMM"),
                n = -1 !== this.options.template.indexOf("MM");
            for (e = 0; 11 >= e; e++) t = o ? moment().date(1).month(e).format("MMMM") : s ? moment().date(1).month(e).format("MMM") : n ? this.leadZero(e + 1) : e + 1, i.push([e, t]);
            return i
        },
        fillYear: function() {
            var t, e, i = [],
                o = -1 !== this.options.template.indexOf("YYYY");
            for (e = this.options.maxYear; e >= this.options.minYear; e--) t = o ? e : (e + "").substring(2), i[this.options.yearDescending ? "push" : "unshift"]([e, t]);
            return i = this.fillCommon("y").concat(i)
        },
        fillHour: function() {
            var t, e, i = this.fillCommon("h"),
                o = -1 !== this.options.template.indexOf("h"),
                s = (-1 !== this.options.template.indexOf("H"), -1 !== this.options.template.toLowerCase().indexOf("hh")),
                n = o ? 1 : 0,
                a = o ? 12 : 23;
            for (e = n; a >= e; e++) t = s ? this.leadZero(e) : e, i.push([e, t]);
            return i
        },
        fillMinute: function() {
            var t, e, i = this.fillCommon("m"),
                o = -1 !== this.options.template.indexOf("mm");
            for (e = 0; 59 >= e; e += this.options.minuteStep) t = o ? this.leadZero(e) : e, i.push([e, t]);
            return i
        },
        fillSecond: function() {
            var t, e, i = this.fillCommon("s"),
                o = -1 !== this.options.template.indexOf("ss");
            for (e = 0; 59 >= e; e += this.options.secondStep) t = o ? this.leadZero(e) : e, i.push([e, t]);
            return i
        },
        fillAmpm: function() {
            var t = -1 !== this.options.template.indexOf("a"),
                e = (-1 !== this.options.template.indexOf("A"), [
                    ["am", t ? "am" : "AM"],
                    ["pm", t ? "pm" : "PM"]
                ]);
            return e
        },
        getValue: function(e) {
            var i, o = {},
                s = this,
                n = !1;
            return t.each(this.map, function(t) {
                if ("ampm" !== t) {
                    var e = "day" === t ? 1 : 0;
                    return o[t] = s["$" + t] ? parseInt(s["$" + t].val(), 10) : e, isNaN(o[t]) ? (n = !0, !1) : void 0
                }
            }), n ? "" : (this.$ampm && (o.hour = 12 === o.hour ? "am" === this.$ampm.val() ? 0 : 12 : "am" === this.$ampm.val() ? o.hour : o.hour + 12), i = moment([o.year, o.month, o.day, o.hour, o.minute, o.second]), this.highlight(i), e = void 0 === e ? this.options.format : e, null === e ? i.isValid() ? i : null : i.isValid() ? i.format(e) : "")
        },
        setValue: function(e) {
            function i(e, i) {
                var o = {};
                return e.children("option").each(function(e, s) {
                    var n, a = t(s).attr("value");
                    "" !== a && (n = Math.abs(a - i), ("undefined" == typeof o.distance || n < o.distance) && (o = {
                        value: a,
                        distance: n
                    }))
                }), o.value
            }
            if (e) {
                var o = "string" == typeof e ? moment(e, this.options.format, !0) : moment(e),
                    s = this,
                    n = {};
                o.isValid() && (t.each(this.map, function(t, e) {
                    "ampm" !== t && (n[t] = o[e[1]]())
                }), this.$ampm && (n.hour >= 12 ? (n.ampm = "pm", n.hour > 12 && (n.hour -= 12)) : (n.ampm = "am", 0 === n.hour && (n.hour = 12))), t.each(n, function(t, e) {
                    s["$" + t] && ("minute" === t && s.options.minuteStep > 1 && s.options.roundTime && (e = i(s["$" + t], e)), "second" === t && s.options.secondStep > 1 && s.options.roundTime && (e = i(s["$" + t], e)), s["$" + t].val(e))
                }), this.options.smartDays && this.fillCombo("day"), this.$element.val(o.format(this.options.format)).change())
            }
        },
        highlight: function(t) {
            t.isValid() ? this.options.errorClass ? this.$widget.removeClass(this.options.errorClass) : this.$widget.find("select").css("border-color", this.borderColor) : this.options.errorClass ? this.$widget.addClass(this.options.errorClass) : (this.borderColor || (this.borderColor = this.$widget.find("select").css("border-color")), this.$widget.find("select").css("border-color", "red"))
        },
        leadZero: function(t) {
            return 9 >= t ? "0" + t : t
        },
        destroy: function() {
            this.$widget.remove(), this.$element.removeData("combodate").show()
        }
    }, t.fn.combodate = function(i) {
        var o, s = Array.apply(null, arguments);
        return s.shift(), "getValue" === i && this.length && (o = this.eq(0).data("combodate")) ? o.getValue.apply(o, s) : this.each(function() {
            var o = t(this),
                n = o.data("combodate"),
                a = "object" == typeof i && i;
            n || o.data("combodate", n = new e(this, a)), "string" == typeof i && "function" == typeof n[i] && n[i].apply(n, s)
        })
    }, t.fn.combodate.defaults = {
        format: "DD-MM-YYYY HH:mm",
        template: "D / MMM / YYYY   H : mm",
        value: null,
        minYear: 1970,
        maxYear: 2015,
        yearDescending: !0,
        minuteStep: 5,
        secondStep: 1,
        firstItem: "empty",
        errorClass: null,
        customClass: "",
        roundTime: !0,
        smartDays: !1
    }
}(window.jQuery);
define("combodate", ["jquery","moment"], function(){});
